import { DragIcon } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import styles from './HorizontalCardWithTitle.module.scss';
import { Props } from './HorizontalCardWithTitle.types';

/** @deprecated use `Card` instead */
export const HorizontalCardWithTitle = ({
  title,
  subtitles,
  className,
  onClick,
  leftActions,
  rightActions,
  leftIcon,
  classNameLeftIcon,
  leftSideClassName,
  titleClassname,
  subtitlesClassname,
  draggable,
}: Props) => (
  <div className={classnames(styles.container, className)} onClick={onClick}>
    {leftActions}
    <div style={{ flex: 1 }} className={classnames(styles.leftSide, leftSideClassName)}>
      {draggable && <DragIcon className={styles.dragIcon} />}
      {leftIcon && (
        <div className={classnames(styles.leftIcon, classNameLeftIcon)}> {leftIcon}</div>
      )}
      <div className={styles.leftTextContainer}>
        <div className={classnames(styles.title, titleClassname)}>{title}</div>
        {subtitles && (
          <div className={classnames(styles.description, subtitlesClassname)}>
            {subtitles?.map((subtitle, idx) => (
              <div key={idx}>{subtitle}</div>
            ))}
          </div>
        )}
      </div>
    </div>
    {rightActions}
  </div>
);
